import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { TranslationKeyEnum } from '../../types/constants';
interface ChevronRightIconProps {
  /**    * Icon color, defaults to currentColor    */ fill?: string;
  /**    * Icon width    */ width?: number;
  /**    * Icon height    */ height?: number;
  /**    * CSS className    */ className?: string;
}
const ChevronRightIcon: React.FC<ChevronRightIconProps> = ({
  fill = 'currentColor',
  width = 24,
  height = 24,
  className = '',
}) => {
  const { t } = useTranslation();
  const ariaLabel = t(TranslationKeyEnum.ChevronRight);
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={ariaLabel}
      role="img"
    >
      {' '}
      <path
        d="M9.29 15.88L13.17 12L9.29 8.12C8.9 7.73 8.9 7.1 9.29 6.71C9.68 6.32 10.31 6.32 10.7 6.71L15.29 11.3C15.68 11.69 15.68 12.32 15.29 12.71L10.7 17.3C10.31 17.69 9.68 17.69 9.29 17.3C8.91 16.91 8.9 16.27 9.29 15.88Z"
        fill={fill}
      />{' '}
    </svg>
  );
};
export default ChevronRightIcon;
